import { setCookie, getCookie } from '../base/_utilities';

const modal_element = document.getElementById('apm-dialog');

/**
 *
 *
 *
 */
const init = function() {

	setupAnnouncementModal();
	setupBioModals();

};


const setupAnnouncementModal = function() {

	if ( modal_element !== null ) {

		const cookieDuration = ( modal_element.getAttribute( 'data-apm-modal-cookie-duration' ) ) ? modal_element.getAttribute( 'data-apm-modal-cookie-duration' ) : 0;
		const cookieName		 = ( modal_element.getAttribute( 'data-apm-modal-cookie-id' ) ) ? modal_element.getAttribute( 'data-apm-modal-cookie-id' ) : '';
		const modalViewed	 	 = getCookie( cookieName );

		// Instantiate a new A11yDialog module
		const dialog = new A11yDialog(modal_element);

		if ( !modalViewed ) {
			setTimeout( () => {
				dialog.show();
				setCookie(cookieName, true, cookieDuration);
			}, 2000 );
		}

	}

}


const setupBioModals = function() {

	const body 		 = document.body;
	const triggers = document.querySelectorAll('.js-modal-trigger');
	const targets  = document.querySelectorAll('.js-bio-modal');
	
	// relocate modals to be direct children of the body element
	// at bottom of DOM
	if ( targets ) {
		targets.forEach( ( element ) => {
			body.appendChild( element );
		} );
	}

	// setup the triggers used to display the modals
	if ( triggers ) {
		triggers.forEach( ( element ) => {
			element.addEventListener( 'click', () => {
				const targetID = element.getAttribute( 'data-bio-popup-target' );
				const modalElement = document.getElementById( targetID );
				const dialog = new A11yDialog( modalElement );
				dialog.show();
			} );
		} );
	}

}


const api = {
	init: init
};

export default api;